import styled from 'styled-components';
const SpinnerStyle = styled.div `
  @keyframes rotating {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;

  & svg {
    animation: rotating 1s linear infinite;
  }
`;
export default SpinnerStyle;
//# sourceMappingURL=SpinnerStyle.js.map